import { Button, Layout, Row, Space, Typography, message } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import RevoCard from "../../../assets/images/revo_card.webp";
import ArrowLeftIconComponent from "../../../components/ArrowLeftIconComponent";
import FanCardModalComponent from "../../../components/FanCardModalComponent";
import FanDeleteCardModalComponent from "../../../components/FanDeleteCardModalComponent";
// import StickyButtonComponent from "../../../components/StickyButtonComponent";
import { SavedCardServices } from "../../../services/savedCard.service";
import "./index.less";
import Loader from "../../../components/loader/Loader";

const SavedCardsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [allCards, setAllCards] = useState<any>([]);
  const [isCardModalOpen, setIsCardModalOpen] = useState<boolean>(false);
  const [isDeleteCardModalOpen, setIsDeleteCardModalOpen] = useState<boolean>(false);
  const [selectedCardId, setSelectedCardId] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    //getCurrentPaymentGateway();
    getAllCards();
  }, []);

  const getAllCards = async () => {
    setIsLoading(true);
    await SavedCardServices.allSavedCards()
      .then((res: any) => {
        setAllCards(res?.data?.cards || []);
        setIsLoading(false);
      })
      .catch((e: any) => {
        setIsLoading(false);

        console.log("Error occurred while getting all cards", e);
        message.error(t("something-want-wrong"));
      });
  };

  // const getCurrentPaymentGateway = async () => {
  //   await settingService.getPayentGateway().then((res: any) => {
  //     if (res?.paymentGateway === "stripe") {
  //       navigate("/fan/home");
  //     }
  //   });
  // };

  const handleDeleteClick = (id: any) => {
    setSelectedCardId(id);
    setIsCardModalOpen(false);
    setIsDeleteCardModalOpen(true);
  };

  const deleteCard = async () => {
    setIsDeleteCardModalOpen(false);

    await SavedCardServices.deleteSavedCard(selectedCardId)
      .then((res: any) => {
        if (res.status === 0) {
          const newData = allCards?.filter((item: any) => item?.id !== selectedCardId);
          setAllCards(newData);
        } else {
          message.error(t("something-want-wrong"));
        }
      })
      .catch((e: any) => {
        console.log(e);
        message.error(t("something-want-wrong"));
      });
  };

  const handleCardClick = (cardId: any) => {
    setSelectedCardId(cardId);
    setIsCardModalOpen(true);
  };

  // const bankAccountConvert = (value: any) => {
  //   const firstChar = value.substring(0, 2);
  //   return `${firstChar + "** **** **** **** "}${value.slice(-3)}`;
  // };

  function formatCardNumber(first6: any, last4: any) {
    const hiddenSection = " * ".repeat(6);

    // Combine the parts and ensure the output is exactly 16 characters long
    return `${first6}${hiddenSection}${last4}`;
  }

  return (
    <Layout className="savedCardWrapper gradient-background ">
      <Layout.Header className="header savedCardbg">
        <Row className="relative justify-content-center">
          <ArrowLeftIconComponent left={0} />
          <Typography.Text className="header-title-black-24">{t("saved-cards")}</Typography.Text>
        </Row>
      </Layout.Header>
      <Layout.Content className="content creatorPaymentMethodContentWrapper ">
        <Row className="relative">
          <Typography.Text className="font-36-bold text-white-color">{t("efficient-payment")}</Typography.Text>
        </Row>

        <Row>
          <Space className="w-full" direction="vertical">
            {isLoading ? (
              <div className="mt-40">
                <Loader />
              </div>
            ) : allCards?.length !== 0 ? (
              allCards?.map((item: any, index: React.Key) => {
                return (
                  <Row onClick={() => handleCardClick(item.id)} key={index}>
                    <Row className="w-full justify-content-center">
                      <Row className="save-card-image-container">
                        <img src={RevoCard} alt="RevoCard" className="responsive-image" />
                        <Row className="save-card-card-overlay">
                          <Row className="save-card-top-left">
                            <Typography.Text className="title-save-card text-gradient-color">{t("registered-card")}</Typography.Text>
                          </Row>
                          <Row className="save-card-top-right">
                            <Button
                              className="delete-button"
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteClick(item.id);
                              }}
                            >
                              {t("Delete")}
                            </Button>
                          </Row>
                          <Row className="save-card-bottom-left">
                            <Typography.Text className="username-save-card text-gradient-color">{item?.cardholderName}</Typography.Text>
                            <Typography.Text className="info-save-card text-gradient-color">
                              {formatCardNumber(item?.first6, item?.last4)}
                            </Typography.Text>
                          </Row>
                        </Row>
                      </Row>
                    </Row>
                  </Row>
                );
              })
            ) : (
              <Row>
                <Typography.Text className="relative font-24-bold text-white mx-auto mt-40 mb-20">{t("no-card-found")}</Typography.Text>
              </Row>
            )}
          </Space>
        </Row>
        {/* <StickyButtonComponent title={t("add-card")} handleClickButton={() => navigate("/common/saveNewCard")} /> */}

        <FanCardModalComponent
          isOpen={isCardModalOpen}
          onClose={() => {
            setIsCardModalOpen(false);
          }}
          deleteCard={() => handleDeleteClick(selectedCardId)}
        />

        <FanDeleteCardModalComponent
          isOpen={isDeleteCardModalOpen}
          onClose={() => {
            setIsDeleteCardModalOpen(false);
          }}
          onYesClick={deleteCard}
        />
      </Layout.Content>
    </Layout>
  );
};

export default SavedCardsPage;
